import imgBtn from '@assets/web-v3-images/btn-buy.png';
import imgchange from '@assets/web-v3-images/change-pass.png';
import { Text } from '@radix-ui/themes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import PATH from '../config/PATH';
import { setCookieChangePw } from '../utils/cookie';
import PopupFrame from './popups/ui-1';

// onClose: do popupManager truyền vào (popup này chạy trong hàng đợi ở
// ModalRender, priority 2 — pu8). Gọi khi user đóng để bật cooldown.
function ModalChangePassword({ onClose }) {
	const { t } = useTranslation();
	const [isModalVisible, setIsModalVisible] = useState(false)
	const navigate = useNavigate()
	const location = useLocation()
	// Trước đây dep là prop `changePage` (LayoutApp set lại mỗi lần đổi route).
	// Popup giờ do ModalRender render nên bám thẳng vào pathname, không cần prop.
	useEffect(() => {
		if (location.pathname === PATH.CHANGE_PASSWORD) {
			setIsModalVisible(false)
		} else setIsModalVisible(true);
	}, [location.pathname])
	const handleCancel = () => {
		setIsModalVisible(false);
		setCookieChangePw()
		onClose?.()
	}
	const handleOk = () => {
		navigate(PATH.CHANGE_PASSWORD)
		setCookieChangePw()
		onClose?.()
	}

	// Điều kiện "guide tour đã xong" trước đây nằm ở useShowPopup() tại đây, nhưng
	// popup này giờ chạy trong hàng đợi ưu tiên: nếu tự render null thì nó vẫn ăn
	// mất suất 1-popup/page-load mà không hiện gì. Điều kiện đó đã chuyển lên
	// isEligible của "pu8" trong utils/popupRegistry.jsx.
	return (
		<PopupFrame
			open={isModalVisible}
			onOpenChange={handleCancel}
			title={t("modal.modal_login.emergency_alert")}
			classNames='!max-w-150'
		>
			<div className='flex flex-col justify-center items-center'>
				<img src={imgchange} alt="" className='w-full px-15 sm:px-35 py-5 sm:py-10' />
				<p className='text-[14px] sm:text-[20px] text-center text-[rgba(161,92,7,1)] font-medium px-5 sm:px-15'>
					{t("modal.modal_login.for_your_security_please_set_a_new")}
				</p>
				<div className='flex justify-between w-full gap-5 sm:gap-10 px-5 sm:px-15 pt-5'>
					<button className={`relative w-full cursor-pointer btn-click-active max-w-[100%] mt-[4%] mb-[10%] outline-none`}
						onClick={handleCancel}
					>
						<img
							src={imgBtn}
							className="block w-full h-auto"
							alt="Revive"
						/>

						<Text
							className="absolute inset-0 flex items-center justify-center text-lg sm:text-2xl font-extrabold text-white"
							style={{
								WebkitTextStroke: "1px #FF692E",
								paintOrder: "stroke fill",
							}}
						>
							{t("modal.modal_login.cancel")}
						</Text>
					</button>
					<button className={`relative w-full cursor-pointer btn-click-active max-w-[100%] mt-[4%] mb-[10%] outline-none`}
						onClick={handleOk}
					>
						<img
							src={imgBtn}
							className="block w-full h-auto"
							alt="Revive"
						/>

						<Text
							className="absolute inset-0 flex items-center justify-center text-lg sm:text-2xl font-extrabold text-white"
							style={{
								WebkitTextStroke: "1px #FF692E",
								paintOrder: "stroke fill",
							}}
						>
							{t("modal.modal_login.update")}
						</Text>
					</button>
				</div>
			</div>

		</PopupFrame>);
}

export default ModalChangePassword;